export default __webpack_public_path__ + "static/media/gallery1.f92488a4.jpg";